<template>
  <v-container fluid class="pa-6 page-container">
    <v-row>
      <!-- Section Commandes -->
      <v-col cols="12" md="4" order-md="1">
        <div class="section-header mb-6">
          <v-icon class="section-icon">shopping_cart</v-icon>
          <span class="section-title">MES COMMANDES</span>
        </div>

        <v-card class="order-card mb-4">
          <router-link
            :to="{
              name: 'listeCommandeDemandeur',
              params: {
                statutCommandeIP: 'NA'
              }
            }"
            class="order-link"
          >
            <div class="d-flex align-center">
              <v-avatar class="order-badge" size="56">
                <span class="badge-number">{{ commandeQte.qteCommandeDuJour }}</span>
              </v-avatar>
              <span class="order-label flex-grow-1">Commandes de la journée</span>
              <v-icon class="arrow-icon">arrow_forward</v-icon>
            </div>
          </router-link>
        </v-card>

        <v-card class="order-card mb-4" elevation="2">
          <router-link
            :to="{
              name: 'listeCommandeDemandeur',
              params: {
                statutCommandeIP: 'EN_TRAITEMENT'
              }
            }"
            class="order-link"
          >
            <div class="d-flex align-center">
              <v-avatar class="order-badge" size="56">
                <span class="badge-number">{{ commandeQte.qteCommandeStatutEnTraitement }}</span>
              </v-avatar>
              <span class="order-label flex-grow-1">Commandes transmises - non confirmées</span>
              <v-icon class="arrow-icon">arrow_forward</v-icon>
            </div>
          </router-link>
        </v-card>

        <v-card class="order-card mb-4" elevation="2">
          <router-link
            :to="{
              name: 'listeCommandeDemandeur',
              params: { statutCommandeIP: 'BROUILLON' }
            }"
            class="order-link"
          >
            <div class="d-flex align-center">
              <v-avatar class="order-badge" size="56">
                <span class="badge-number">{{ commandeQte.qteCommandeStatutBrouillon }}</span>
              </v-avatar>
              <span
                v-if="commandeQte.indCommandeBrouillonDateJour == true"
                class="order-label flex-grow-1 alert-text"
              >Commandes en brouillon</span>
              <span v-else class="order-label flex-grow-1">Commandes en brouillon</span>
              <v-icon class="arrow-icon">arrow_forward</v-icon>
            </div>
          </router-link>
        </v-card>

        <!-- Boutons d'action -->
        <div class="action-buttons mt-8">
          <v-btn
            v-if="
              this.$store.getters.currentUser != null &&
                this.$store.getters.currentUser.agentData.indCapaciteFinanciere
            "
            :to="{ name: 'capaciteFinanciere' }"
            class="action-btn mb-3"
            block
            large
            elevation="1"
          >
            <v-icon left>monetization_on</v-icon>
            <span>Capacité financière</span>
          </v-btn>

          <v-btn
            v-if="this.$store.getters.currentUser != null"
            :to="{ name: 'capaciteAchat' }"
            class="action-btn"
            block
            large
            elevation="1"
          >
            <v-icon left>add_chart</v-icon>
            <span>Calcul capacité d'achat</span>
          </v-btn>
        </div>
      </v-col>

      <!-- Section Communications -->
      <v-col cols="12" md="8" align-self="start">
        <v-card class="communication-card pa-6" elevation="3">
          <template>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="communication-content" v-html="communication.communication"></div>
          </template>

          <div class="delivery-notes mb-4">
            <p class="delivery-notes-intro">
              Les dates de livraison indiquées dans l'horaire de transmission et de livraison sont
              uniquement à titre indicatif. La SAQ n'est aucunement responsable de tout retard dans la
              livraison des commandes. Malgré les jours prévus à l'horaire de transmission et de livraison,
              les commandes en livraison en succursale seront disponibles dès que la SAQ communiquera avec vous.
            </p>
            <br />
            <ul>
              <li>
                Les livraisons sont effectuées dans un délai minimum de 48 heures, et ce, en fonction de
                la journée de livraison du client.
              </li>
              <li>
                Les livraisons sont effectuées selon les modalités de livraison inscrites au dossier du client
                (succursale ou à l'établissement).
              </li>
              <li>Les clients "particuliers" et "entreprises" seront livrés à l'une des succursales désignées.</li>
            </ul>
            <br />
            <p>
              Pour connaitre l'horaire de transmission et de livraison, veuillez inscrire le numéro de client
              ou plus bas le numéro de succursale dans le champ en jaune approprié à l'intérieur du fichier
              HoraireLivraison.xlsx.
            </p>
            <p>
              Pour les titulaires de permis desservis par le Centre de distribution de Québec, les commandes
              doivent être acheminées avant 9h le matin et ce, 48h avant la journée de livraison du client.
            </p>
          </div>
          <!-- Tableau horaire de livraison -->
          <table class="simple-schedule mt-4">
            <thead>
              <tr>
                <th>Commandes acheminées avant 16h</th>
                <th>Pour la livraison</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Lundi</td>
                <td>Mercredi</td>
              </tr>
              <tr>
                <td>Mardi</td>
                <td>Jeudi</td>
              </tr>
              <tr>
                <td>Mercredi</td>
                <td>Vendredi</td>
              </tr>
              <tr>
                <td>Jeudi</td>
                <td>Mardi</td>
              </tr>
              <tr>
                <td>Vendredi</td>
                <td>Mardi</td>
              </tr>
            </tbody>
          </table>

          <v-data-iterator :items="fichiers" hide-default-footer dense no-data-text>
            <template v-slot:default="props">
              <div v-if="fichiers != null && fichiers.length > 0" class="documents-section mt-6">
                <div class="documents-header mb-4">
                  <v-icon left small>description</v-icon>Documents d'informations
                </div>
                <div class="documents-list">
                  <div
                    v-for="item in props.items"
                    :key="item.name"
                    class="document-item"
                    @click="exportFichier(item)"
                  >
                    <v-icon small class="mr-2">insert_drive_file</v-icon>
                    <span class="document-name">{{ item.nomFichier }}</span>
                    <v-icon small class="ml-auto">download</v-icon>
                  </div>
                </div>
              </div>
            </template>
          </v-data-iterator>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Accueil',
  data() {
    return {
      fichiers: [],
      commandeQte: {},
      communication: { communication: null },
    }
  },
  computed: {
    agentConnecte: function () {
      return this.$store.getters.agentConnecte
    },
    nom: function () {
      return this.$store.getters.agentConnecteInfosJDE.nom
    },
  },

  beforeMount() {
    axios
      .get(`/commandesip/${this.agentConnecte.idDemandeur}/qte`)
      .then((response) => {
        let resp = response.data
        switch (resp.codeRetour) {
          case 'OK':
            this.commandeQte = resp.resultat
            break
          default:
            console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
            this.$store.dispatch(
              'afficherError',
              `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
            )
            break
        }
      })
      .catch((error) => {
        //console.log('error=' + error)
        let texte = ''
        if (error.response) {
          texte = `Status: ${error.response.status} Data: ${error.response.data}`
          console.log(texte)
        } else {
          texte = `Une erreur technique est survenue: ${error.message}`
        }
        this.$store.dispatch('afficherError', texte)
      })

    axios
      .get(`/communication/selontype/${'AGENT'}`)
      .then((response) => {
        let resp = response.data
        switch (resp.codeRetour) {
          case 'OK':
            this.communication = resp.resultat
            this.lireDocuments()
            break
          default:
            console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
            this.$store.dispatch(
              'afficherError',
              `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
            )
            break
        }
      })
      .catch((error) => {
        //console.log('error=' + error)
        let texte = ''
        if (error.response) {
          texte = `Status: ${error.response.status} Data: ${error.response.data}`
          console.log(texte)
        } else {
          texte = `Une erreur technique est survenue: ${error.message}`
        }
        this.$store.dispatch('afficherError', texte)
      })
  },

  methods: {
    lireDocuments() {
      axios
        .get(`/communication/obtenirfichiers/${this.communication.id}`)
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.fichiers = resp.resultat
              break
            case 'W001':
              this.fichiers = []
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
    exportFichier(fichier) {
      axios({
        url: '/communication/' + fichier.id + '/fichier',
        method: 'get',
        responseType: 'arraybuffer',
        //headers: { Accept: 'application/pdf' }
      })
        .then((response) => {
          let ct = response.headers['content-type']
          // if (ct == 'application/json') {
          //   const str = new TextDecoder().decode(response.data)
          //  const resp = JSON.parse(str)
          //  const msg = this.$fmtApiErr(resp)
          //   console.log(msg)
          //  this.$store.dispatch('afficherError', msg)
          //} else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fichier.nomFichier)
          document.body.appendChild(link)
          link.click()
          //}
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
  },
}
</script>

<style scoped>
/* Container */
.page-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  min-height: 100vh;
}

/* Section Header */
.section-header {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 2px solid #00838e;
}

.section-icon {
  color: #00838e;
  font-size: 28px !important;
}

.section-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #2c3e50;
  margin-left: 12px;
  text-transform: uppercase;
}

/* Order Cards */
.order-card {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

.order-link {
  display: block;
  padding: 16px 20px;
  text-decoration: none !important;
  color: inherit;
}

.order-badge {
  background: linear-gradient(135deg, #00838e 0%, #00acc1 100%) !important;
  color: white;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(0, 131, 142, 0.3);
}

.warning-badge {
  background: linear-gradient(135deg, #f57c00 0%, #ffb74d 100%) !important;
  box-shadow: 0 4px 12px rgba(245, 124, 0, 0.3);
}

.draft-badge {
  background: linear-gradient(135deg, #7b1fa2 0%, #ba68c8 100%) !important;
  box-shadow: 0 4px 12px rgba(123, 31, 162, 0.3);
}

.badge-number {
  font-size: 18px;
  font-weight: 700;
}

.order-label {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-left: 16px;
  line-height: 1.4;
}

.alert-text {
  color: #d32f2f !important;
}

.arrow-icon {
  color: #90a4ae;
  transition: transform 0.3s ease, color 0.3s ease;
}

.order-card:hover .arrow-icon {
  transform: translateX(4px);
  color: #00838e;
}

/* Action Buttons */
.action-btn {
  background: linear-gradient(135deg, #00838e 0%, #00acc1 100%) !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 10px !important;
  transition: all 0.3s ease;
}

.action-btn .v-icon {
  margin-right: 8px;
}

/* Communication Card */
.communication-card {
  border-radius: 16px !important;
  background: white;
  min-height: 300px;
}

.communication-content {
  font-size: 15px;
  line-height: 1.7;
  color: #37474f;
}

.delivery-notes {
  background: #ffffff;
  padding: 16px 18px;
  color: #37474f;
  font-size: 14px;
  line-height: 1.5;
}

.delivery-notes p {
  margin: 0 0 10px 0;
}

.delivery-notes-intro {
  font-style: italic;
}

.delivery-notes p:last-child {
  margin-bottom: 0;
}

.delivery-notes ul {
  margin: 0 0 10px 20px;
  padding: 0;
}

.delivery-notes li {
  margin-bottom: 6px;
}

.delivery-notes li:last-child {
  margin-bottom: 0;
}

/* Documents Section */
.documents-section {
  border-top: 1px solid #eceff1;
  padding-top: 20px;
}

.documents-header {
  font-size: 13px;
  font-weight: 700;
  color: #546e7a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
}

.documents-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.document-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.document-item:hover {
  background: #e3f2fd;
}

.document-name {
  font-size: 14px;
  font-weight: 500;
  color: #37474f;
}

.document-item .v-icon {
  color: #78909c;
}

/* Simple Schedule Table */
.simple-schedule {
  border-collapse: collapse;
  font-size: 13px;
  color: #546e7a;
  margin: 12px auto 0 auto;
}

.simple-schedule th,
.simple-schedule td {
  border: 1px solid #e0e0e0;
  padding: 8px 16px;
  text-align: center;
}

.simple-schedule th {
  background: #f5f5f5;
  font-weight: 600;
  color: #37474f;
}

.document-item:hover .v-icon {
  color: #00838e;
}

/* Responsive */
@media (max-width: 960px) {
  .order-label {
    font-size: 13px;
  }

  .communication-card {
    margin-top: 24px;
  }
}

/* Links */
.v-application a {
  color: inherit;
  text-decoration: none;
}
</style>
